//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    /**
     * Testimonial list
     */
    testimonials: {
      type: Array,
      required: true
    },
    /**
     * Background color
     */
    backgroundColor: {
      type: String,
      default: '#8DB5D9'
    },
    /**
     * Background color
     */
    showTakeQuizButton: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      currentSlide: 0
    }
  },
  computed: {
    testimonialsGroup () {
      if (this.testimonials.length > 3) {
        const array = this.testimonials
        const shuffledArray = array.sort((a, b) => 0.5 - Math.random())
        return this.isTablet() ? this.createGroups(shuffledArray, 4) : this.createGroups(shuffledArray, 5)
      }
      return this.createGroups(this.testimonials, 1)
    },
    showArrows () {
      return ((this.isMobile() && this.testimonials.length > 1) || (!this.isMobile() && this.testimonialsGroup.length > 1))
    },
    cssVars () {
      return {
        '--background-color': this.backgroundColor
      }
    }
  },
  methods: {
    nextSlide () {
      this.$refs.carousel.nextSlide()
    },
    prevSlide () {
      this.$refs.carousel.prevSlide()
    },
    slideChanged (slide) {
      this.currentSlide = slide
    },
    createGroups (mainList, numGroups) {
      const elementsPerGroup = Math.ceil(mainList.length / numGroups)
      return new Array(numGroups)
        .fill('')
        .map((el, index) => mainList.slice(index * elementsPerGroup, (index + 1) * elementsPerGroup))
    },
    pauseVideo () {
      const videos = document.getElementsByClassName('testimonial-video__video')
      for (const item of videos) {
        if (!item.paused) {
          item.pause()
        }
      }
    }
  }
}
